<p [ngClass]="{border: showBorder}" i18n>Нет данных по запросу</p>
